import { CMSApiBase, createCmsUrl } from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface TermsAndConditionsEEApi extends CMSApiBase {
  title: string;
  text: string;
  effectiveFrom: string;
  lastUpdated: string;
}

export const getTermsAndConditionsEEUrl = (lang: string) =>
  createCmsUrl({
    path: 'term-and-conditions-ee',
    queryData: { ...getCMSLocale(lang) },
  });

export const fetchTermsAndConditionsEE = async (lang: string) => {
  const response = await fetcherCMS<TermsAndConditionsEEApi>(
    getTermsAndConditionsEEUrl(lang)
  );
  return { data: response };
};
